// extracted by mini-css-extract-plugin
export default {"posts-list":"PostsList_posts-list__xe4na","show-more-btn":"PostsList_show-more-btn__2F2-M"};